require('./src/SVG');
require('./src/SVG.VML');
require('./src/Canvas');
require('./src/Path.Transform');
require('./src/Path.Drag');

module.exports = L.Path.Drag;



//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet-path-drag/index.js
// module id = 25
// module chunks = 4